import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './pages/AdminDashboard.tsx';
import ScrapersDashboard from './pages/ScrapersDashboard.tsx';
import HostsDashboard from './pages/HostsDashboard.tsx';
import MissionsDashboard from './pages/MissionsDashboard.tsx';
import MarketingDashboard, { MarketingAppDashboard } from './pages/MarketingDashboard.tsx';
import Login from './pages/Login.tsx';
import { ProtectedRoute } from './components/ProtectedRoute.tsx';

const App: React.FC = () => {
  return (
    <div className="App">
      <div className="admin-dashboard">
        <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/scrapers"
            element={
              <ProtectedRoute>
                <ScrapersDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/hosts"
            element={
              <ProtectedRoute>
                <HostsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/missions"
            element={
              <ProtectedRoute>
                <MissionsDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/marketing"
            element={
              <ProtectedRoute>
                <MarketingDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/marketing/spontane"
            element={
              <ProtectedRoute>
                <MarketingAppDashboard appId="spontane" section="actions" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/marketing/spontane/evidence"
            element={
              <ProtectedRoute>
                <MarketingAppDashboard appId="spontane" section="evidence" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/marketing/spontane/memory"
            element={
              <ProtectedRoute>
                <MarketingAppDashboard appId="spontane" section="memory" />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/marketing/spontane/skills" element={<Navigate to="/admin/marketing/spontane/memory" />} />
          <Route path="/admin/marketing/spontane/actions" element={<Navigate to="/admin/marketing/spontane" />} />
          <Route
            path="/admin/marketing/emulsify"
            element={
              <ProtectedRoute>
                <MarketingAppDashboard appId="emulsify" section="actions" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/marketing/emulsify/evidence"
            element={
              <ProtectedRoute>
                <MarketingAppDashboard appId="emulsify" section="evidence" />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/marketing/emulsify/memory"
            element={
              <ProtectedRoute>
                <MarketingAppDashboard appId="emulsify" section="memory" />
              </ProtectedRoute>
            }
          />
          <Route path="/admin/marketing/emulsify/skills" element={<Navigate to="/admin/marketing/emulsify/memory" />} />
          <Route path="/admin/marketing/emulsify/actions" element={<Navigate to="/admin/marketing/emulsify" />} />
        </Routes>
      </div>
    </div>
  );
};

export default App;